async function searchSchools(query) {
    try {
        const url = new URL("https://app.spirithero.com/process-on-request.php");

        url.searchParams.append("stkn", "");
        url.searchParams.append("rfor", "search_collection");
        url.searchParams.append("search", query);

        const response = await fetch(url.toString());

        if (!response.ok) {
            throw new Error(`HTTP Error: ${response.status}`);
        }

        const data = await response.json();

        if (data.SUCCESS === "TRUE") {
            renderSearchResults(data.storeData);
        } else {
            renderSearchResults([]);
        }

    } catch (error) {
        console.error(error);
        renderSearchResults([]);
    }
}

function renderSearchResults(stores) {

    const results = document.getElementById("school-search-results");

    if (!stores.length) {
        results.innerHTML = "<div class='search-item'>No collections found</div>";
        return;
    }

    let html = "";

    stores.forEach(store => {
        html += `
            <div class="search-item"
                 data-handle="${store.shop_collection_handle}">
                ${store.store_name}
            </div>
        `;
    });

    results.innerHTML = html;

    results.querySelectorAll(".search-item").forEach(item => {
        item.addEventListener("click", function () {

            const handle = this.dataset.handle;

            if (handle) {
                window.location.href = "/collections/" + handle;
            }
        });
    });
}

document.addEventListener("DOMContentLoaded", function () {

    const input = document.querySelector(".search_box");
    let timer;

    input.addEventListener("input", function () {

        clearTimeout(timer);

        const query = this.value.trim();

        if (query.length < 2) {
            document.getElementById("school-search-results").innerHTML = "";
            return;
        }

        timer = setTimeout(() => {
            searchSchools(query);
        }, 300);
    });

});